import { render, staticRenderFns } from "./consumerInsightBarChart.vue?vue&type=template&id=0ef60412&scoped=true"
import script from "./consumerInsightBarChart.vue?vue&type=script&lang=js"
export * from "./consumerInsightBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef60412",
  null
  
)

export default component.exports